'use client';

import { useState } from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import css from './FAQAccordion.module.css';

const faqData = [
  { question: 'home.faq.question01', answer: 'home.faq.answer01' },
  { question: 'home.faq.question02', answer: 'home.faq.answer02' },
  { question: 'home.faq.question03', answer: 'home.faq.answer03' },
  { question: 'home.faq.question04', answer: 'home.faq.answer04' },
  { question: 'home.faq.question05', answer: 'home.faq.answer05' },
  // { question: 'home.faq.question06', answer: 'home.faq.answer06' },
  { question: 'home.faq.question07', answer: 'home.faq.answer07' },
  {
    question: 'home.faq.question08', answer: <div>
      <p className={css.textp1}><FormattedMessage id='home.faq.answer08.p1' /></p>

      <ul className={css.ul}>
        <li><FormattedMessage id='home.faq.answer08.li1' values={{
          strong: chunks => <strong>{chunks}</strong>,
        }} /></li>
        <li><FormattedMessage id='home.faq.answer08.li2' values={{
          strong: chunks => <strong>{chunks}</strong>,
        }} /></li>
      </ul>

      <p className={css.textp2}><FormattedMessage id='home.faq.answer08.p2' values={{
        strong: chunks => <strong>{chunks}</strong>,
      }} /></p>
      <p className={css.textp3}><FormattedMessage id='home.faq.answer08.p3' values={{
        strong: chunks => <strong>{chunks}</strong>,
      }} /></p>
      <p className={css.textp4}><FormattedMessage id='home.faq.answer08.p4' /></p>
    </div>
  },
  { question: 'home.faq.question09', answer: 'home.faq.answer09' }
];

const FAQAccordion = () => {
  const intl = useIntl();
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className={css.accordion}>
      {faqData.map((item, index) => {
        const isActive = index === activeIndex;

        return (
          <div
            key={index}
            className={`${css.item} ${isActive ? css.active : ''}`}
            onClick={() => toggle(index)}
          >
            <div className={css.header}>
              <h3 className={css.question}>
                {intl.formatMessage({ id: item.question })}
              </h3>
              <span className={css.icon}>{isActive ? '−' : '+'}</span>
            </div>

            <div className={`${css.contentWrapper} ${isActive ? css.open : ''}`}>
              <div className={css.content}>
                {typeof item.answer === 'string' ? (
                  <p>
                    {intl.formatMessage({ id: item.answer })}
                  </p>
                ) : (
                  item.answer
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
